import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select'

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';

class AdminAddCourseEntity extends Component {

  constructor(props){
    super(props);
    this.state={
      data: {
        purchaseItemType: [],
        purchaseEntity: [],
        purchaseItemCriteria: '',
        purchaseEntityCriteria: 1,
        purchaseItem: [],
        itemName: '',
        itemDescription: '',
        itemPrice: '',
        currency: '',
        active: 1,
        imgLink: '',
        revenueShare: '',
        startDate: '',
        endDate: '',
        hours: '',
        minutes: '',
        competencyList: [],
        selectedCompetency: [],
        disableForSelfPaced: false
      },
      entityName: '',
      purchaseItemChange: false,
      selectedItemParent: [],
      errorMsg: '',
      saveDisable: false,
    }
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    return api.getPurchaseEntities(this.props.user.accessToken)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseEntity = result.data
        }
        return api.getPurchaseItemType(this.props.user.accessToken)
      })
      .then((result) =>{
        if(result.status === 'success'){
          data.purchaseItemType= result.data
        }
        return api.getResponse(this.props.user.accessToken, 'admin/taxonomy_details/2')
      })
      .then((result) => {
        if(result.status === 'success'){
          data.competencyList = result.data
        }
        this.setState({data: data})
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Exception in Fetching Details'})
      })
  }

  handlePurchaseItemType = (e) => {

    let data = Object.assign({}, this.state.data)
    data.purchaseItemCriteria = e.target.value
    this.setState({data: data})

    api.getPurchaseItem(this.props.user.accessToken, data.purchaseItemCriteria, data.purchaseEntityCriteria)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseItem = result.data
        }
        this.setState({data: data})
      })
  }

  handlePurchaseEntity = (e) => {

    let data = Object.assign({}, this.state.data)
    data.purchaseEntityCriteria = e.target.value
    data.purchaseItemCriteria = ''
    data.purchaseItem = []
    let entityType = data.purchaseEntity.filter((eachEntity) => parseInt(data.purchaseEntityCriteria) === eachEntity.id)
    if (entityType[0] && entityType[0].entity_type === 'SELF PACED') {
      data.hours = ''
      data.minutes = ''
      data.startDate = ''
      data.endDate = ''
      data.disableForSelfPaced = true
    } else {
      data.disableForSelfPaced = false
    }
    this.setState({data: data, selectedItemParent: ''})
  }

  onInputChange = evt => {
    let data = Object.assign({}, this.state.data)
    data[evt.target.name] = evt.target.value
    this.setState({data: data})
  }; 

  handleCompetencyChange = (option) => {
    let data = Object.assign({}, this.state.data)
    data.selectedCompetency = option
    this.setState({ data })
  }

  onActiveChange = evt => {
    let data = Object.assign({}, this.state.data)
    data.active = evt.target.value
    this.setState({data: data})
  };

  handleItemParentChange = (option) => {
    this.setState(state => {
        return {
            purchaseItemChange: true,
            selectedItemParent : option
        };
    });
  }

  handlePurchaseItemSubmit = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)

    const reg = new RegExp('^[0-9]+$');
    let entityType = data.purchaseEntity.filter( (eachEntity) => parseInt(data.purchaseEntityCriteria) === eachEntity.id)
    if (entityType[0] && entityType[0].entity_type === 'SELF PACED') {
      if(
        data.itemName === '' || data.itemDescription === '' || data.itemPrice === '' ||
        data.currency === '' || data.active === '' || data.imgLink === ''  || data.selectedCompetency.length === 0
      ){
        return this.setState({errorMsg: 'All the fields are mandatory except start date, end date, and duration'})
      } 
    }
    else {
      if(
        data.itemName === '' || data.itemDescription === '' || data.itemPrice === '' ||
        data.currency === '' || data.active === '' || data.imgLink === ''  || data.startDate === '' || data.endDate === '' || !data.hours || !data.minutes || data.selectedCompetency.length === 0
      ){
        return this.setState({errorMsg: 'All the fields are mandatory'})
      } else if (reg.test(data.hours) === false && reg.test(data.minutes) === false) {
        return this.setState({ errorMsg: 'Hours and Minutes is not valid' })
      } else if (reg.test(data.hours) === false) {
        return this.setState({ errorMsg: 'Hours is not valid' })
      } else if (reg.test(data.minutes) === false) {
        return this.setState({ errorMsg: 'Minutes is not valid' })
      } else if (data.minutes > 59) {
        return this.setState({ errorMsg: 'Minutes should not be greater than 59' })
      }
    }
    this.setState({saveDisable: true})
    let values;
    values = {
      'name': data.itemName,
      'description': data.itemDescription,
      'currency': data.currency,
      'amount': parseInt(data.itemPrice),
      'active': parseInt(data.active),
      'purchase_item_type_id': parseInt(data.purchaseItemCriteria),
      'purchase_entity_id': parseInt(data.purchaseEntityCriteria),
      'img_link': data.imgLink,
      'revenue_share': data.revenueShare
    }

    if (entityType[0] && entityType[0].entity_type !== 'SELF PACED') {
      values.start_date = data.startDate,
      values.end_date = data.endDate,
      values.duration = `${data.hours}:${data.minutes}`
    }

    let selectedCompetencyIds = []
      if (data.selectedCompetency.length !== 0) {
        data.selectedCompetency.forEach( (competency) => (
          selectedCompetencyIds.push({
            "item_type": "Learning Taxonomy",
            "active" : 1,
            "item_id": competency.value
          })
        ))
        values.purchase_item_mappings_attributes = selectedCompetencyIds
      }

    if (this.state.purchaseItemChange === true) {
      var myStringArray = this.state.selectedItemParent;
      var arrayLength = myStringArray.length;
      let selectedItemString = []
      for (var i = 0; i < arrayLength; i++) {
          selectedItemString.push(parseInt(myStringArray[i].value))
      }
      values = Object.assign({'parent_purchase_id': selectedItemString}, values)
    }
    else{
      values = Object.assign({'parent_purchase_id': []}, values)
    }
    api.createPurchaseItem(this.props.user.accessToken, values)
      .then((result) => {
          if (result.status === 'success'){
            this.setState({errorMsg: result.message})
            return
          }
          else{
              this.setState({errorMsg: result.message, saveDisable: false})
          }
      })
  }

  render() {
    let data = Object.assign({}, this.state.data)
    let purchaseEntityComponent, purchaseItemTypeComponent, formComponent;
    let entityId = data.purchaseItemCriteria
    purchaseEntityComponent = (
      <Select 
        onChange={this.handlePurchaseEntity} 
        value={data.purchaseEntityCriteria}
      >
       {data.purchaseEntity.map((entity) =>(
         <option key ={entity.id} value={entity.id}>{entity.name}</option>
        ))}
      </Select>
    )

    purchaseItemTypeComponent = (
      <Select 
          onChange={this.handlePurchaseItemType} 
          value={data.purchaseItemCriteria}
          placeholder="--- Select Purchase Item Type ---"
      >
     {data.purchaseItemType.map((item) =>(
         <option key={item.id} value={item.id}>{item.name}</option>
      ))} 
      </Select>
    )

    let activeComponent = (
      <Select
        onChange={this.onActiveChange} 
        value={data.active}
      >
        <option value = "1">Active</option>
        <option value = "0">Inactive</option>
      </Select>
    )

    return(
      <div>
        <GridCell span="12">
          <Typography use="headline6">Course Packages</Typography>
        </GridCell>
        <Grid>
        <GridCell span="12">
          <form onSubmit= {this.handlePurchaseItemSubmit}>
            <GridCell span="12">
              <TextField fullwidth label="Add Name" autoComplete="off" name="itemName" onChange={this.onInputChange} value={data.itemName} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Add Description" autoComplete="off" name="itemDescription" onChange={this.onInputChange} value={data.itemDescription} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Add Currency" autoComplete="off" name="currency" onChange={this.onInputChange} value={data.currency} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Add Price" autoComplete="off" name="itemPrice" onChange={this.onInputChange} value={data.itemPrice} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Image Link " autoComplete="off" name="imgLink" onChange={this.onInputChange} value={data.imgLink} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Centa Revenue Share " type="number" autoComplete="off" name="revenueShare" onChange={this.onInputChange} value={data.revenueShare} style={{ height: '140%' }}/>
            </GridCell>
            {purchaseEntityComponent}
            {purchaseItemTypeComponent}
            {activeComponent}
            <GridCell span="12">
              <TextField type="date" className="datepicker-padding" label="Start Date" autoComplete="off" name="startDate" onChange={this.onInputChange}
                disabled={data.disableForSelfPaced} value={data.startDate}/>
           </GridCell>
           <GridCell span="12">
                <TextField type="date" className="datepicker-padding" label="End Date" autoComplete="off" name="endDate" onChange={this.onInputChange}
                disabled={data.disableForSelfPaced} value={data.endDate}/>
           </GridCell>
           <GridCell span="12">
              <label style={{ marginRight: '4rem'}}>Duration:</label>
              <TextField className='text_input' type="number" label="Hours" autoComplete="off" name="hours" onChange={this.onInputChange}
                disabled={data.disableForSelfPaced}
                value={data.hours} />
                <span style={{ marginLeft: '1rem', marginRight: '1rem' }}> : </span>
              <TextField className='text_input' type="number" label="Minutes" autoComplete="off" name="minutes" onChange={this.onInputChange} 
                disabled={data.disableForSelfPaced}
                value={data.minutes} />
              {/* <TextField fullwidth label="Duration" autoComplete="off" name="duration" onChange={this.onInputChange} value={data.duration} style={{ height: '140%' }}/>   */}
           </GridCell>
           <br/>
          <GridCell span="12">
            <Reactsel 
              name="selectedCompetency"
              onChange={this.handleCompetencyChange}
              value={data.selectedCompetency}
              options={data.competencyList}
              placeholder="-- Select Competency --"
              isMulti>
            </Reactsel>
          </GridCell>
           <br/>
            <GridCell span = "12">
              <Reactsel
                      name="purchaseItemList"
                      onChange={this.handleItemParentChange}
                      value={this.state.selectedItemParent}
                      options={data.purchaseItem}
                      placeholder="--Select Course Item Parent--"
                      isMulti>
              </Reactsel>
            </GridCell>
            <br/>
            <Button raised disabled={this.state.saveDisable}>Save</Button>
          </form>
          <StatusMessage error_msg = {this.state.errorMsg} />
        </GridCell>
      </Grid>
      </div>
    );
  }
}

// class AdminAddCourseEntityDetail extends Component {

//   constructor(props) {
//     super(props);
//     this.state ={
//       entityName: '',
//       data: {
//         itemName: '',
//         itemDescription: '',
//         itemPrice: '',
//         currency: '',
//         active: 1,
//       },
//       purchaseItemChange: false,
//       selectedItemParent: [],
//       errorMsg: '',
//       saveDisable: false,
//     }
//   }

//   componentDidMount() {

//   }

//   onInputChange = evt => {
//     let data = Object.assign({}, this.state.data)
//     data[evt.target.name] = evt.target.value
//     this.setState({data: data})
//   }; 

//   onActiveChange = evt => {
//     let data = Object.assign({}, this.state.data)
//     data.active = evt.target.value
//     this.setState({data: data})
//   };

//   handleItemParentChange = (option) => {
//     this.setState(state => {
//         return {
//             purchaseItemChange: true,
//             selectedItemParent : option
//         };
//     });
//   }

//   handlePurchaseItemSubmit = (e) => {
//     e.preventDefault()
//     if((this.state.data.itemName === '') || (this.state.data.itemDescription === '') || (this.state.data.itemPrice === '') || (this.state.data.currency === '') || (this.state.data.active === '')){
//       return this.setState({errorMsg: 'All the fields are mandatory'})
//     }
//     this.setState({saveDisable: true})
//     let values;
//     values = {
//       'name': this.state.data.itemName,
//       'description': this.state.data.itemDescription,
//       'currency': this.state.data.currency,
//       'amount': parseInt(this.state.data.itemPrice),
//       'active': parseInt(this.state.data.active),
//       'purchase_item_type_id': parseInt(this.props.purchaseItemTypeId),
//       'purchase_entity_id': parseInt(this.props.purchaseEntityId),
//     }
//     if (this.state.purchaseItemChange === true) {
//       var myStringArray = this.state.selectedItemParent;
//       var arrayLength = myStringArray.length;
//       let selectedItemString = []
//       for (var i = 0; i < arrayLength; i++) {
//           selectedItemString.push(parseInt(myStringArray[i].value))
//       }
//       values = Object.assign({'parent_purchase_id': selectedItemString}, values)
//     }
//     else{
//       values = Object.assign({'parent_purchase_id': []}, values)
//     }
//     api.createPurchaseItem(this.props.accessToken, values)
//       .then((result) => {
//           if (result.status === 'success'){
//             this.setState({errorMsg: result.message})
//             return
//           }
//           else{
//               this.setState({errorMsg: result.message, saveDisable: false})
//           }
//       })
//   }

//   render() {
//     let activeComponent = (
//       <Select
//         onChange={this.onActiveChange} 
//         value={this.state.data.active}
//       >
//         <option value = "1">Active</option>
//         <option value = "0">Inactive</option>
//       </Select>
//     )
//     return(
//       <Grid>
//         <GridCell span="12">
//           <form onSubmit= {this.handlePurchaseItemSubmit}>
//             <GridCell span="12">
//               <TextField fullwidth label="Add Name" autoComplete="off" name="itemName" onChange={this.onInputChange} value={this.state.data.itemName} style={{ height: '140%' }}/>
//             </GridCell>
//             <GridCell span="12">
//               <TextField fullwidth label="Add Description" autoComplete="off" name="itemDescription" onChange={this.onInputChange} value={this.state.data.itemDescription} style={{ height: '140%' }}/>
//             </GridCell>
//             <GridCell span="12">
//               <TextField fullwidth label="Add Currency" autoComplete="off" name="currency" onChange={this.onInputChange} value={this.state.data.currency} style={{ height: '140%' }}/>
//             </GridCell>
//             <GridCell span="12">
//               <TextField fullwidth label="Add Price" autoComplete="off" name="itemPrice" onChange={this.onInputChange} value={this.state.data.itemPrice} style={{ height: '140%' }}/>
//             </GridCell>
//             {this.props.purchaseEntity}
//             {this.props.purchaseItemType}
//             {activeComponent}
//             <br/>
//             <GridCell span = "12">
//               <Reactsel
//                       name="purchaseItemList"
//                       onChange={this.handleItemParentChange}
//                       value={this.state.selectedItemParent}
//                       options={this.props.purchaseItem}
//                       placeholder="--Select Course Item Parent--"
//                       isMulti>
//               </Reactsel>
//             </GridCell>
//             <br/>
//             <Button raised disabled={this.state.saveDisable}>Save</Button>
//           </form>
//           <StatusMessage error_msg = {this.state.errorMsg} />
//         </GridCell>
//       </Grid>
//     );
//   }
// }

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAddCourseEntity);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAddCourseEntity.jsx